function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
/* eslint-disable react/destructuring-assignment */
import React, { Component } from "react";
import ReactDOMServer from "react-dom/server";
import noop from "lodash/noop";
import { PageletContainer as GenericPageletContainer, RemotePagelet } from "@xo-union/pagelet";
import PropTypes from "prop-types";
import ReactPagelet from "./ReactPagelet/index.js";
var PageletContainer = /*#__PURE__*/function (_Component) {
  _inherits(PageletContainer, _Component);
  var _super = _createSuper(PageletContainer);
  function PageletContainer() {
    var _this;
    _classCallCheck(this, PageletContainer);
    _this = _super.apply(this, arguments);
    /**
     * Remove ability to change props that may cause a re-render. If they change, that would trigger
     * a re-render which would unmount the pagelet without a proper clean up
     */
    _defineProperty(_assertThisInitialized(_this), "containerId", _this.props.containerId);
    _defineProperty(_assertThisInitialized(_this), "links", _this.props.links);
    _defineProperty(_assertThisInitialized(_this), "ssi", _this.props.ssi);
    _defineProperty(_assertThisInitialized(_this), "renderPlaceholder", _this.props.renderPlaceholder);
    _defineProperty(_assertThisInitialized(_this), "renderError", _this.props.renderError);
    _defineProperty(_assertThisInitialized(_this), "pageletContainer", new GenericPageletContainer(_this.containerId, {
      errorPagelet: new ReactPagelet(_this.renderError),
      props: _this.props.pageletProps
    }));
    _defineProperty(_assertThisInitialized(_this), "remotePagelet", new RemotePagelet({
      links: _this.links,
      jsExportName: _this.props.exportName
    }));
    return _this;
  }
  _createClass(PageletContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.pageletContainer.addEventListener('error', this.props.onError);
      this.pageletContainer.mount(this.remotePagelet);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.pageletContainer.setProps(this.props.pageletProps);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.pageletContainer.unmount();
    }
  }, {
    key: "render",
    value: function render() {
      if (this.ssi) {
        /* eslint-disable react/no-danger */

        var pageletHTML = ReactDOMServer.renderToStaticMarkup( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
          "data-pagelet-role": "placeholder"
        }, this.renderPlaceholder())));
        return /*#__PURE__*/React.createElement("div", {
          "data-pagelet-container-id": this.containerId,
          suppressHydrationWarning: true,
          dangerouslySetInnerHTML: {
            __html: "<!--#include virtual=\"".concat(this.links.ssi, "\" -->").concat(pageletHTML)
          }
        });
      }
      return /*#__PURE__*/React.createElement("div", {
        "data-pagelet-container-id": this.containerId
      }, /*#__PURE__*/React.createElement("div", {
        "data-pagelet-role": "placeholder"
      }, this.renderPlaceholder()));
    }
  }]);
  return PageletContainer;
}(Component);
export { PageletContainer as default };
_defineProperty(PageletContainer, "defaultProps", {
  exportName: 'default',
  pageletProps: {},
  ssi: false,
  renderPlaceholder: function renderPlaceholder() {
    return 'Loading...';
  },
  renderError: function renderError() {
    return 'There was an error loading this part of the page. Try again soon.';
  },
  onError: noop
});
process.env.NODE_ENV !== "production" ? PageletContainer.propTypes = {
  /**
   * Unique ID to assign to pagelet
   */
  containerId: PropTypes.string.isRequired,
  /**
   * Asset links
   */
  links: PropTypes.shape({
    css: PropTypes.shape({
      toString: PropTypes.func.isRequired
    }),
    js: PropTypes.shape({
      toString: PropTypes.func.isRequired
    }),
    ssi: PropTypes.shape({
      toString: PropTypes.func.isRequired
    })
  }).isRequired,
  /**
   * Name of export where pagelet is implemented in remote JS
   * */
  exportName: PropTypes.string,
  /**
   * Props to pass to pagelet
   * */
  pageletProps: PropTypes.shape({}),
  /**
   * Enable SSI rendering (for server side rendering)
   */
  ssi: PropTypes.bool,
  /**
   * Render function for pagelet placeholder. This will be rendered while the pagelet loads
   * if the pagelet is rendered on the client side.
   */
  renderPlaceholder: PropTypes.func,
  /**
   * Render function for pagelet error. This will be rendered when an error occurs. Rendering the error
   * can be prevented via the `onError` callback. For example, when the pagelet is fully rendered, it may
   * not page sense to render an error because the broken pagelet may still provide a usable experience
   * (via links, etc).
   */
  renderError: PropTypes.func,
  /**
   * Handle pagelet container error
   */
  onError: PropTypes.func
} : void 0;